module.exports = __webpack_public_path__ + "img/table_orange.271a6bb0.svg";